// extracted by mini-css-extract-plugin
module.exports = {"settlementCard":"ClaimSettlement_settlementCard__10Zo9","label":"ClaimSettlement_label__2MZhn"};